// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3KTG8","text":"SelectPayment_text__PJ-kU","title":"SelectPayment_title__3BFpG","btn":"SelectPayment_btn__3lhG0"};